export default {
  DISABLE: 'MESSAGE_CREATOR_DISABLE',
  ENABLE: 'MESSAGE_CREATOR_ENABLE',
  ERROR: 'MESSAGE_CREATOR_ERROR',
  HEIGHT: 'MESSAGE_CREATOR_HEIGHT'
};
